import {baseUrl} from '../shared/baseUrl';

export var skipCountUpdateServer = (hindiTextId)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'hindiText/skip/'+hindiTextId,{
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}

export var getAudioId = (fileName)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'audio/getAudioId/'+fileName,{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response=>response.json())
    .catch((err)=>console.log(err));
}